import React from 'react';
import cx from 'classnames';
import { allowedColors, allowedSizes } from './constants';
import fontStyles from './Font.module.scss';
import styles from './Icon.module.scss';
const Icon = ({ name, className, size = 'lg', color = 'default', ...rest }) => (React.createElement("span", { "data-icon": name, style: {
        fontSize: typeof size === 'number' ? `${Number(size).toString()}px` : '',
        ...(!allowedColors.includes(color) ? { color } : {}),
    }, className: cx(styles.icon, fontStyles[`tt-icon-${name}`], {
        ...(typeof size !== 'number'
            ? { [styles[`font-size-${size}`]]: allowedSizes.includes(size) }
            : {}),
        [styles[`font-color-${color}`]]: allowedColors.includes(color),
    }, className), ...rest }));
export default Icon;
